export function normalizeNode<T extends { name?: string }>(nodeInfo: T | string) {
    if (typeof nodeInfo === 'string') {
        return { name: nodeInfo };
    }

    return nodeInfo;
}
